module.exports = __webpack_public_path__ + "img/07.3f075b67.png";